import { createContext, useState, PropsWithChildren } from "react"
import { toCamelCase } from "~/util/toCamelCase"

export interface SurveyStatusContext {
  status: Record<string, boolean>
  completeSurvey: (surveyId: string) => void
  getSurveyNumber: (surveyId: string) => number
  nextSurvey: string | null
}

export const SurveyContext = createContext<SurveyStatusContext | null>(null)

export type SurveyContextProviderProps = {
  surveys: string[]
  allSurveys: Array<string>
}

export const SurveyContextProvider = (
  props: PropsWithChildren<SurveyContextProviderProps>
): JSX.Element => {
  const [status, setStatus] = useState<Record<string, boolean>>(() =>
    props.allSurveys.reduce(
      (aggr, surveyId) => ({
        ...aggr,
        [surveyId]: props.surveys.indexOf(toCamelCase(surveyId)) < 0
      }),
      {}
    )
  )

  const nextSurvey =
    Object.entries(status).find((entry) => !entry[1])?.[0] || null

  const completeSurvey = (surveyName: string) => {
    setStatus((prevData) => {
      const newState: Record<string, boolean> = { ...prevData }
      newState[surveyName] = true
      return newState
    })
  }

  const getSurveyNumber = (surveyId: string) =>
    props.allSurveys.indexOf(surveyId) + 1

  return (
    <SurveyContext.Provider
      value={{
        status,
        completeSurvey,
        nextSurvey,
        getSurveyNumber
      }}
    >
      {props.children}
    </SurveyContext.Provider>
  )
}
